// extracted by mini-css-extract-plugin
export default {"items":"row_ite_hVxVu","item":"row_ite_WBPu8","card":"row_car_3om3w","scrollSnap":"row_scr_1YIu2"};